<template>
  <v-tabs fixed-tabs :v-once="query">
    <v-tab ripple>
      Workflow
    </v-tab>
    <v-tab ripple>
      Status History
    </v-tab>
    <v-tab ripple>
      Modified History
    </v-tab>
    <v-tab-item>
      <v-stepper :value="steps" vertical class="policyLifeCycle" v-if="loadNormalWorkFlow">
        <v-stepper-step step="1" v-bind:complete="steps > 1">
          <span>Sales Opportunity</span>
          <span v-if="!query">
            <v-btn flat icon color="primary" @click="$emit('salesOpportunity')">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </span>
        </v-stepper-step>
        <v-stepper-content step="1">
          <div v-if="steps > 1">
            <div v-if="showProspect">
              <v-subheader>Requested By:</v-subheader>
              <div v-if="this.quotation.commonForm.salesOppName">
                <v-icon>mdi-comment-account</v-icon>
                <span>{{quotation.commonForm.salesOppName}}</span>
              </div>
              <div v-if="this.quotation.commonForm.salesOppPhone">
                <v-icon>mdi-phone</v-icon>
                <span>{{quotation.commonForm.salesOppPhone}}</span>
              </div>
              <div v-if="this.quotation.commonForm.salesOppEmail">
                <v-icon>mdi-email</v-icon>
                <span>{{quotation.commonForm.salesOppEmail}}</span>
              </div>
            </div>
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" v-bind:complete="steps > 2">
          {{quoteStatusConst.NQ}}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div v-if="steps >= 2">
            <template v-if="nqDetails">
              <v-subheader>Created By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{nqDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(nqDetails.statusDate)}}</span>
              </div>
            </template>
            <div>
              <v-icon>mdi-domain</v-icon>
              <span>{{intermediary}}</span>
            </div>
          </div>
        </v-stepper-content>
        <v-stepper-step step="3" v-bind:complete="steps > 3">
          {{quoteStatusConst.QPA}}
        </v-stepper-step>
        <v-stepper-content step="3">
          <div v-if="steps >= 3">
            <template v-if="qpaDetails">
              <v-subheader>Submitted By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{qpaDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(qpaDetails.statusDate)}}</span>
              </div>
            </template>
          </div>
        </v-stepper-content>
        <v-stepper-step step="4" v-bind:complete="steps > 4">
          {{currentStatus === 'QD'? quoteStatusConst.QD : quoteStatusConst.QA}}
        </v-stepper-step>
        <v-stepper-content step="4">
          <div v-if="steps >= 4">
            <template v-if="loadBelowQA && qaDetails">
              <v-subheader>Approved By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{qaDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(qaDetails.statusDate)}}</span>
              </div>
            </template>
            <template v-else-if="!loadBelowQA && qdDetails">
              <v-subheader>Declined By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{qdDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(qdDetails.statusDate)}}</span>
              </div>
            </template>
          </div>
        </v-stepper-content>
        <v-stepper-step step="5" v-bind:complete="steps > 5" v-if="loadBelowQA">
          {{quoteStatusConst.NP}}
        </v-stepper-step>
        <v-stepper-content step="5" v-if="loadBelowQA">
          <div v-if="steps >= 5">
            <template v-if="npDetails">
              <v-subheader>Confimed By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{npDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(npDetails.statusDate)}}</span>
              </div>
            </template>
          </div>
        </v-stepper-content>
        <v-stepper-step step="6" v-bind:complete="steps > 6" v-if="loadBelowQA">
          {{quoteStatusConst.PPA}}
        </v-stepper-step>
        <v-stepper-content step="6" v-if="loadBelowQA">
          <div v-if="steps >= 6">
            <template v-if="ppaDetails">
              <v-subheader>Submitted By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{ppaDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(ppaDetails.statusDate)}}</span>
              </div>
            </template>
          </div>
        </v-stepper-content>
        <v-stepper-step step="7" v-bind:complete="steps > 7" v-if="loadBelowQA">
          {{currentStatus === 'PD'? quoteStatusConst.PD : quoteStatusConst.IF}}
        </v-stepper-step>
        <v-stepper-content step="7" v-if="loadBelowQA">
          <div v-if="steps >= 7">
            <template v-if="loadBelowIF && ifDetails">
              <v-subheader>Approved By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{ifDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(ifDetails.statusDate)}}</span>
              </div>
            </template>
            <template v-else-if="!loadBelowIF && pdDetails">
              <v-subheader>Declined By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{pdDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(pdDetails.statusDate)}}</span>
              </div>
            </template>
          </div>
        </v-stepper-content>
        <v-stepper-step step="8" v-bind:complete="steps > 8" v-if="loadBelowIF">
          {{quoteStatusConst.PO}}
        </v-stepper-step>
        <v-stepper-content step="8" v-if="loadBelowIF">
          <div v-if="steps >= 8">
            <template v-if="poDetails">
              <v-subheader>Posted By:</v-subheader>
              <div>
                <v-icon>mdi-account-edit</v-icon>
                <span>{{poDetails.name}}</span>
              </div>
              <div>
                <v-icon>mdi-calendar-clock</v-icon>
                <span>{{formatDateTime(poDetails.statusDate)}}</span>
              </div>
              <div>
                <v-icon title="Policy No">mdi-key</v-icon>
                <span>{{$store.state.agency.quotation.commonInfo.polNo}}</span>
              </div>
            </template>
          </div>
        </v-stepper-content>
      </v-stepper>
      <v-stepper :value="steps" vertical class="policyLifeCycle" v-else>
        <v-stepper-step step="1" v-bind:complete="true">
          <span>{{currentStatusLabel}}</span>
        </v-stepper-step>
        <v-stepper-content step="1">
          <template v-if="currentStatus === 'VO' && voDetails">
            <v-subheader>Void By:</v-subheader>
            <div>
              <v-icon>mdi-account-edit</v-icon>
              <span>{{voDetails.name}}</span>
            </div>
            <div>
              <v-icon>mdi-calendar-clock</v-icon>
              <span>{{formatDateTime(voDetails.statusDate)}}</span>
            </div>
          </template>
          <template v-else-if="currentStatus === 'NTU' && ntuDetails">
            <v-subheader>Status Change By:</v-subheader>
            <div>
              <v-icon>mdi-account-edit</v-icon>
              <span>{{ntuDetails.name}}</span>
            </div>
            <div>
              <v-icon>mdi-calendar-clock</v-icon>
              <span>{{formatDateTime(ntuDetails.statusDate)}}</span>
            </div>
          </template>
          <template v-else-if="currentStatus === 'CL' && clDetails">
            <v-subheader>Cancelled By:</v-subheader>
            <div>
              <v-icon>mdi-account-edit</v-icon>
              <span>{{clDetails.name}}</span>
            </div>
            <div>
              <v-icon>mdi-calendar-clock</v-icon>
              <span>{{formatDateTime(clDetails.statusDate)}}</span>
            </div>
          </template>
          <template v-else-if="currentStatus === 'DC' && dcDetails">
            <v-subheader>Declined By:</v-subheader>
            <div>
              <v-icon>mdi-account-edit</v-icon>
              <span>{{dcDetails.name}}</span>
            </div>
            <div>
              <v-icon>mdi-calendar-clock</v-icon>
              <span>{{formatDateTime(dcDetails.statusDate)}}</span>
            </div>
          </template>
        </v-stepper-content>
      </v-stepper>
    </v-tab-item>
    <v-tab-item>
      <status-history></status-history>
    </v-tab-item>
    <v-tab-item>
      <audit-history></audit-history>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { formatDisplayDateTime } from '@/utils/date'
import { quoteStatus } from '@/const/underwriting'
import StatusHistory from '../../shared/StatusHistory'
import AuditHistory from '../../shared/AuditHistory'

export default {
  computed: {
    currentStatus() {
      return this.$store.state.agency.quotation.commonInfo.statusCode
    },
    steps() {
      // Motor Policy Life Cycle is as such:
      /*
        1: Sales Opportunity / Extra statuses (VO/NTU/CL)
        2: NQ: Quotation
        3: QPA: Quotation Pending Approval
        4: QA/QD: Quotation Approved / Declined
        5: NP: Proposal
        6: PPA: Proposal Pending Approval
        7: IF/PD: In-Force / Proposal Declined
        8: PO: Policy
      */
      let lifeCycle = 1
      if (this.currentStatus === 'NQ') {
        lifeCycle = 2
      } else if (this.currentStatus === 'QPA') {
        lifeCycle = 3
      } else if (this.currentStatus === 'QA' || this.currentStatus === 'QD') {
        lifeCycle = 4
      } else if (this.currentStatus === 'NP') {
        lifeCycle = 5
      } else if (this.currentStatus === 'PPA') {
        lifeCycle = 6
      } else if (this.currentStatus === 'IF' || this.currentStatus === 'PD') {
        lifeCycle = 7
      } else if (this.currentStatus === 'PO') {
        lifeCycle = 8
      } else {
        lifeCycle = 1
      }

      return lifeCycle
    },
    quotation() {
      return this.$store.state.agency.quotation
    },
    showProspect() {
      if (this.quotation.commonForm.salesOppName || this.quotation.commonForm.salesOppEmail || this.quotation.commonForm.salesOppPhone) {
        return true
      } else {
        return false
      }
    },
    intermediary() {
      // return extractLabel(this.$store.state.agency.quotationSettings.intermediaries, this.quotation.commonForm.intermediary)
      return this.quotation.commonForm.intermediary + ' - ' + this.quotation.queryInfo.intermediary
    },
    quoteStatusConst() {
      return quoteStatus
    },
    loadNormalWorkFlow() {
      // Steps will only be 1 if its Sales Opp or other statuses
      // Once reach this stage, it shouldn't be sales opp anymore
      if (this.steps === 1) {
        return false
      } else {
        return true
      }
    },
    currentStatusLabel() {
      if (quoteStatus[this.currentStatus]) {
        return quoteStatus[this.currentStatus]
      } else {
        return 'Unknown Status'
      }
    },
    loadBelowQA() {
      // If its Quote Declined, we do not want to show the rest of the steps
      if (this.currentStatus === 'QD') {
        return false
      } else {
        return true
      }
    },
    loadBelowIF() {
      if (this.loadBelowQA) {
        if (this.currentStatus === 'PD') {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    nqDetails() {
      return this.getQuoteStatusDetail('NQ')
    },
    qpaDetails() {
      return this.getQuoteStatusDetail('QPA')
    },
    qaDetails() {
      return this.getQuoteStatusDetail('QA')
    },
    qdDetails() {
      return this.getQuoteStatusDetail('QD')
    },
    npDetails() {
      return this.getQuoteStatusDetail('NP')
    },
    ppaDetails() {
      return this.getQuoteStatusDetail('PPA')
    },
    pdDetails() {
      return this.getQuoteStatusDetail('PD')
    },
    ifDetails() {
      return this.getQuoteStatusDetail('IF')
    },
    poDetails() {
      return this.getQuoteStatusDetail('PO')
    },
    voDetails() {
      return this.getQuoteStatusDetail('VO')
    },
    ntuDetails() {
      return this.getQuoteStatusDetail('NTU')
    },
    clDetails() {
      return this.getQuoteStatusDetail('CL')
    },
    dcDetails() {
      return this.getQuoteStatusDetail('DC')
    }
  },
  methods: {
    formatDateTime(date) {
      return formatDisplayDateTime(date)
    },
    getQuoteStatusDetail(statusCode) {
      return this.$store.getters.getQuoteStatusDetail(statusCode)
    }
  },
  components: {
    StatusHistory,
    AuditHistory
  },
  props: {
    query: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
// Will inherit the css from LifeCycle (as this is the child component)
</style>
